export default __webpack_public_path__ + "static/media/eIcon4.a9ed3a8e.svg";